var React = require('react');

function PlayTriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M 6.991528,22 V 2 L 21,12 Z"}));
}

PlayTriangleInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = PlayTriangleInline;

PlayTriangleInline.default = PlayTriangleInline;
